import { emailOTPClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

const AUTH_ORIGIN_BY_APP_HOST: Readonly<Record<string, string>> = {
  "sk.xunpanziyou.com": "https://crm.xunpanziyou.com",
  "workbench-staging.xunpanziyou.com": "https://crm-staging.xunpanziyou.com",
};

export function resolveAuthClientBaseUrl(input: {
  readonly origin?: string;
  readonly hostname?: string;
}): string | undefined {
  if (input.hostname) {
    const authOrigin = AUTH_ORIGIN_BY_APP_HOST[input.hostname];
    if (authOrigin) return authOrigin;
  }
  return input.origin;
}

/** Shared Better Auth client; Workbench hosts call the canonical CRM auth origin. */
export const authClient = createAuthClient({
  baseURL:
    typeof window === "undefined"
      ? undefined
      : resolveAuthClientBaseUrl({
          origin: window.location.origin,
          hostname: window.location.hostname,
        }),
  fetchOptions: { credentials: "include" },
  plugins: [emailOTPClient()],
});
